export default __webpack_public_path__ + "static/media/bottom-smoke.2fcc5f72.webp";